import { render, staticRenderFns } from "./BlocksAndAlertsIcon.vue?vue&type=template&id=4227d924&scoped=true&"
import script from "./BlocksAndAlertsIcon.vue?vue&type=script&lang=js&"
export * from "./BlocksAndAlertsIcon.vue?vue&type=script&lang=js&"
import style0 from "./BlocksAndAlertsIcon.vue?vue&type=style&index=0&id=4227d924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227d924",
  null
  
)

export default component.exports